import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { api } from "@/lib/api";
import { JOURNAL } from "@/constants/testIds";

export default function JournalDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 800], [0, 160]);

  useEffect(() => {
    api.get(`/posts/${slug}`).then((r) => setPost(r.data));
  }, [slug]);

  if (!post) {
    return (
      <main className="pt-40 px-6 md:px-10 min-h-screen">
        <div className="text-sm text-[color:var(--vv-bone-dim)]">Loading…</div>
      </main>
    );
  }

  return (
    <main className="pt-24 md:pt-32 pb-32">
      <section className="relative min-h-[70vh] overflow-hidden border-b vv-line">
        {post.hero_image && (
          <motion.div style={{ y }} className="absolute inset-0">
            <img
              src={post.hero_image}
              alt=""
              className="w-full h-full object-cover grayscale opacity-60"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/40 via-[#050505]/60 to-[#050505]" />
          </motion.div>
        )}
        <div className="relative z-10 max-w-[1200px] mx-auto px-6 md:px-10 pt-40 pb-24">
          <Link
            to="/journal"
            className="text-xs uppercase tracking-[0.3em] text-[color:var(--vv-bone-dim)] vv-link"
          >
            ← Journal
          </Link>
          <div className="mt-8 text-[10px] tracking-[0.35em] uppercase text-[color:var(--vv-ember)]">
            {post.kicker}
          </div>
          <h1
            data-testid={JOURNAL.title}
            className="mt-6 font-serif-vv text-5xl md:text-8xl leading-[0.95] tracking-tight max-w-4xl"
          >
            {post.title}
          </h1>
        </div>
      </section>

      <article className="max-w-[760px] mx-auto px-6 md:px-10 pt-20">
        <p
          data-testid={JOURNAL.body}
          className="font-serif-vv text-2xl md:text-3xl leading-snug text-[color:var(--vv-bone)]/90"
        >
          {post.excerpt}
        </p>
        <div className="mt-12 h-px w-16 bg-[color:var(--vv-ember)]" />
        <p className="mt-12 text-lg leading-[1.8] text-[color:var(--vv-bone)]/85">
          {post.body}
        </p>
      </article>
    </main>
  );
}
